import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../api.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-dialog-facility',
  templateUrl: './dialog-facility.component.html',
  styleUrls: ['./dialog-facility.component.scss']
})
export class DialogFacilityComponent implements OnInit {
  facilityData: any;
  facilityDataView:any;
  mode='View';
  constructor(private apiService: ApiService,
    public dialogRef: MatDialogRef<DialogFacilityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if(this.facilityData.facilityCRM){
      this.apiService.getFacilityByCRMId(this.facilityData.facilityCRM).subscribe(data => {
        if(data){
          this.facilityDataView = data;
        }
      })
    }
  }
  onCloseDialog(){
    this.dialogRef.close({ event: 'cancelConsern' });
  }
}
